<template>
  <div>
    <van-list v-model="loading" :finished-text="finishedText" :finished="finished" @load="load">
      <slot />
    </van-list>
    <div v-if="$parent.initComplete && $parent.list.length == 0" class="noData">{{ title }}</div>
  </div>
</template>
<script>
/**
 * @description 组件使用注意
 * 1、页码的key必须为page
 * 2、单页展示条数必须为pageSize
 * 3、初始化方法名称为init
 * 4、储存数据的集合的key必须为list
 * 5、数据渲染完毕后再调用init的callback
 * this.$nextTick(() => {
      callback && callback(res.data.TotalPages)
    })
 */
export default {
  name: 'NormalList',
  props: {
    title: {
      type: String,
      default: '暂无数据'
    }
  },
  data() {
    return {
      loading: true,
      finished: false,
      finishedText: ''
    }
  },
  methods: {
    load() {
      this.$parent.initComplete = false
      this.loading = true
      this.finishedText = ''
      this.$parent.page += 1
      this.$parent.init(this.$parent.callback)
    },
    refresh() {
      this.$parent.initComplete = false
      this.loading = true
      this.finishedText = ''
      this.$parent.page = 1
      this.$parent.list = []
      this.$parent.init(this.$parent.callback)
    }
  }
}
</script>
<style lang="less" scoped>
.noData {
    color: #969799;
    font-size: 0.18667rem;
    line-height: 0.66667rem;
    text-align: center;
}
</style>
